(function() {
    'use strict';

    var GestioneDocumentiCtrl = function(
        $stateParams,
        messaggiFctr,
        gestioneDocumentiService,
        gestioneUtenteService
    ) {        
        this.loading = 1;
        this.gestioneDocumentiService = gestioneDocumentiService;
        this.gestioneUtenteService = gestioneUtenteService;

        this.init = () => {
            if (this.praticaPic) {
                this.intestatario = this.praticaPic.intestatario;
            }

            if (this.praticaPic && this.praticaPic.intestatario) {
                this.loading--;
                return;
            }

            if (!$stateParams.idPratica) return;

            gestioneUtenteService
                .getPraticaByIdDaPic($stateParams.idPratica)
                .then(
                    (resp) => {
                        if (messaggiFctr.processaResponse(resp)) {
                            return;
                        };
                        
                        this.praticaPic = resp.data.result;
                        this.intestatario = resp.data.result.intestatario;
                        this.setStatoRecuperoRapporti('LOADING');

                        gestioneUtenteService.getRapportiPraticaByIdDaPic($stateParams.idPratica).then(
                            (resp) => {
                                if (messaggiFctr.processaResponse(resp)) {
                                    return;
                                };
                                
                                this.praticaPic.utenzaMito.rapporti = resp.data.result;
                                this.setStatoRecuperoRapporti('OK');
                            },
                            (error) => {
                                messaggiFctr.processaResponse(error);
                                this.setStatoRecuperoRapporti(error.status);
                            }
                        );
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => this.loading--);
        };

        this.init();
    };

    GestioneDocumentiCtrl.$inject = [
        '$stateParams',
        'MitomMessaggiFctr',
        'MitomGestioneDocumentiService',
        'MitomGestioneUtenteService'
    ];

    var TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'mitoman-gestione-documenti/gestioneDocumenti.component.html'
        );
    };
    TemplateUrl.$inject = ['Mitom_CONSTANTS'];

    var GestioneDocumentiComponent = {
        controller: GestioneDocumentiCtrl,
        controllerAs: 'gestioneDocumentiCtrl',
        templateUrl: TemplateUrl,
        bindings: {
            praticaPic: '=?ngModel'
        }
    };

    angular
        .module('cbl.mitomanager.wa')
        .component('mitomgestioneDocumenti', GestioneDocumentiComponent);
})();